import { Button, Stack, Typography, useTheme } from "@mui/material";
import { Check, type LucideIcon } from "lucide-react";
import type { FC } from "react";
import type { AlertTone } from "web_myplann/NotificationCenter/EventAlert/alertTone";
import { GRASS_GREEN_MYPLANN } from "web_myplann/Utils/constants";

type Props = {
	label: string;
	onClick: () => void;
	variant: "contained" | "text";
	ctaButtonColor?: AlertTone["ctaButtonColor"];
	Icon?: LucideIcon;
	subtext?: string;
};

export const EventActionButton: FC<Props> = ({
	label,
	onClick,
	variant,
	ctaButtonColor,
	Icon,
	subtext,
}) => {
	const { spacingTokens } = useTheme();

	return (
		<Stack alignItems="center" gap={spacingTokens.xs} width="100%">
			<Button
				variant={variant === "contained" ? "alertCta" : "alertCtaText"}
				color={variant === "contained" ? ctaButtonColor : undefined}
				fullWidth
				disableElevation
				onClick={onClick}
				startIcon={
					variant === "contained" && Icon ? <Icon size={16} /> : undefined
				}
			>
				{label}
			</Button>
			{subtext && (
				<Stack direction="row" alignItems="center" gap={spacingTokens.xs}>
					<Check size={14} color={GRASS_GREEN_MYPLANN} aria-hidden />
					<Typography variant="deprecatedHint" color={GRASS_GREEN_MYPLANN}>
						{subtext}
					</Typography>
				</Stack>
			)}
		</Stack>
	);
};
